import { render, staticRenderFns } from "./RoleQuotaUpgradeModal.vue?vue&type=template&id=cad5da5a&scoped=true&"
import script from "./RoleQuotaUpgradeModal.vue?vue&type=script&lang=js&"
export * from "./RoleQuotaUpgradeModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleQuotaUpgradeModal.vue?vue&type=style&index=0&id=cad5da5a&prod&lang=scss&"
import style1 from "./RoleQuotaUpgradeModal.vue?vue&type=style&index=1&id=cad5da5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad5da5a",
  null
  
)

export default component.exports